<div class="grid__cell grid__cell--widget widget__bag" [dragula]='"widget-bag"'>
  <div class="widget__wrap">
    <div class="widget" id="pages-widget">
      <h2 class="widget__header">
        <span class="widget__header__title">
          <i class="widget__header__icon ico-angle-down"></i> Nemovitosti</span>
        <span class="widget__header__tools">
          <swb-filter-list (modelChange)="filter($event)"></swb-filter-list>
          <a [routerLink]="['add']" class="cta cta--small cta--green">
            <span class="cta__light">Přidat</span> nemovitost
            <i class="ico-plus"></i>
          </a>
        </span>
      </h2>
      <div class="widget__content">
        <swb-real-estate-list [query]="query"></swb-real-estate-list>
      </div>
    </div>
  </div>
  <swb-estate-formfields></swb-estate-formfields>
</div>
<div class="grid__cell grid__cell--widget widget__bag" [dragula]='"widget-bag"'>
  <swb-estate-agents></swb-estate-agents>
  <swb-developer-projects></swb-developer-projects>
</div>
<router-outlet></router-outlet>